import { Focus, Share2, Layers } from "lucide-react";
import { SectionLabel, MaskedLineInView, FadeUp } from "@/components/Reveal";
import { rules } from "@/data/site";

const icons = { focus: Focus, share: Share2, layers: Layers };

const HowWeWork = () => (
  <section id="how-we-work" data-testid="how-we-work-section" className="relative z-10 w-full px-6 mt-16">
    <div className="glass-surface relative rounded-[32px] py-16 sm:py-24 overflow-hidden">
      <div className="relative site-container">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-8">
          <SectionLabel data-testid="how-we-work-label">How We Work</SectionLabel>
          <h2 className="text-4xl sm:text-6xl lg:text-[68px] font-normal tracking-tight leading-[1.06] lg:text-right lg:max-w-[820px]">
            <MaskedLineInView>
              <span>Three rules we <span className="text-[#8C5EBA] font-medium">don't break.</span></span>
            </MaskedLineInView>
          </h2>
        </div>

        <div className="mt-16 sm:mt-[90px] grid grid-cols-1 md:grid-cols-3 gap-6">
          {rules.map((r, i) => {
            const Icon = icons[r.icon];
            return (
              <FadeUp key={i} delay={i * 0.12} className="h-full">
                <div
                  data-testid={`rule-card-${i}`}
                  className="hww-card h-full p-6 transition-transform duration-500 hover:-translate-y-1.5"
                >
                  <div className="w-16 h-16 rounded-2xl flex items-center justify-center" style={{ background: "rgba(140,94,186,0.2)" }}>
                    <Icon size={32} className="text-[#8C5EBA]" strokeWidth={1.8} />
                  </div>
                  <h3 className="mt-12 lg:mt-16 text-2xl lg:text-[30px] leading-snug tracking-tight">
                    <span className="font-semibold">{r.title[0]}</span>
                    <br />
                    <span className="font-normal">{r.title[1]}</span>
                  </h3>
                  <p className="mt-10 lg:mt-14 text-lg font-normal leading-relaxed text-[#111]/60 pb-2">{r.body}</p>
                </div>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);

export default HowWeWork;
